import React, { useState } from "react";
import Modal from "../../../../Common/Modal";
import RollerLoadingAnimation from "../../StorageCalibration/AutoCalibration/RollerLoadingAnimation";
import MtiButton from "../../../../Buttons/MtiButton";
import "./SlotCorrectionProgressModal";
import { ESuiteModeState } from "../../../../../Model/ModuleState";

type Props = {
  show: boolean;
  onHide: () => void;
  stopSlotCorrection: () => void;
  slotCorrectionState: ESuiteModeState;
};

export default function SlotCorrectionProgressModal({
  show,
  onHide,
  stopSlotCorrection,
  slotCorrectionState,
}: Props) {
  const [doFadeOut, setDoFateOut] = useState(false);

  const onClickTerminate = () => {
    if (slotCorrectionState !== ESuiteModeState.Stopping) {
      stopSlotCorrection();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      hideOnBackdropClick={false}
      className={
        doFadeOut
          ? "auto-calibration-progress-modal calibrating-done"
          : "auto-calibration-progress-modal"
      }
    >
      <Modal.Header
        title={"Correction Slot"}
        hideButtonEnabled={false}
        className="auto-calibration-progress-header"
      />
      <Modal.Body className="auto-calibration-progress-body">
        <RollerLoadingAnimation />
        <div className="progress-title">
          {slotCorrectionState !== ESuiteModeState.Stopping ? (
            <p>Correction Slot is on progress</p>
          ) : (
            <p>The slot correction process is being terminated</p>
          )}
        </div>
        <div className="progress-subtittle">
          {slotCorrectionState !== ESuiteModeState.Stopping
            ? "Please wait for a few moments. This dialog box will be closed automatically after completing task."
            : "Please waiting process till end. The Slot Correction process auto canceled when this process is done."}
        </div>
        {slotCorrectionState !== ESuiteModeState.Stopping ? (
          <MtiButton
            variant="primary"
            colorVariant="error"
            size="large"
            onClick={onClickTerminate}
            style={{
              width: 157,
              alignSelf: "flex-end",
            }}
            disabled={false}
          >
            <span>STOP</span>
          </MtiButton>
        ) : (
          <div style={{ height: 47 }}></div>
        )}
      </Modal.Body>
    </Modal>
  );
}
